<template>
  <div class="space-y-2">
    <label class="block text-xs font-medium text-gray-500 dark:text-gray-400">Date and time</label>

    <input
      type="date"
      :value="date"
      @input="emit('update:date', $event.target.value)"
      class="w-full h-9 px-3 text-sm text-gray-700 dark:text-gray-200 bg-white dark:bg-[#1C2128] border border-gray-200 dark:border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
    />

    <div class="flex items-center gap-2">
      <div class="flex-1">
        <label class="block text-[10px] text-gray-400 dark:text-gray-500 mb-0.5">Start</label>
        <input
          type="time"
          :value="startTime"
          @input="emit('update:startTime', $event.target.value)"
          class="w-full h-9 px-3 text-sm text-gray-700 dark:text-gray-200 bg-white dark:bg-[#1C2128] border border-gray-200 dark:border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <span class="text-gray-400 dark:text-gray-500 mt-4 flex-shrink-0">→</span>
      <div class="flex-1">
        <label class="block text-[10px] text-gray-400 dark:text-gray-500 mb-0.5">End</label>
        <input
          type="time"
          :value="endTime"
          @input="emit('update:endTime', $event.target.value)"
          :class="endBeforeStart ? 'border-red-300 dark:border-red-700 focus:ring-red-500' : 'border-gray-200 dark:border-gray-700 focus:ring-blue-500'"
          class="w-full h-9 px-3 text-sm text-gray-700 dark:text-gray-200 bg-white dark:bg-[#1C2128] border rounded-lg focus:outline-none focus:ring-2"
        />
      </div>
    </div>
    <p v-if="endBeforeStart" class="text-xs text-red-500">End time must be after start time</p>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  date:      { type: String, required: true },
  startTime: { type: String, required: true },
  endTime:   { type: String, required: true },
})

const emit = defineEmits(['update:date', 'update:startTime', 'update:endTime'])

const endBeforeStart = computed(() =>
  props.startTime && props.endTime && props.endTime <= props.startTime
)
</script>
